<script>
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  import request from 'superagent';
  import Screen from './screen.svelte';
  import Components from './components.svelte';
  import { my_folders as default_folders_store } from '../stores.js'
  
  const dispatch = createEventDispatcher();
  const defaultDocument = { id: null, language: "cz", title: "", uri: "" };
  
  export let locale = 'cs';
  export let document_form_id = window.ENFORCE_DOCUMENT_FORM_ID;
  export let document_id = null;
  export let item = Object.assign({}, defaultDocument);
  export let folders_store = default_folders_store;
  
  let response = null;
  let folders = [];
  
  folders_store.subscribe(value => {
    if (value  != 'undefined' || !value)
      folders = value;
  });
  
  function cancel() {
    dispatch('document', null);
  }
  
  function commit() {
    let submit = item.id ? request.put : request.post;
  
    submit(`/form/${document_form_id}`)
    .send(Object.assign({}, item))
    .then(resp => {
      if (!item.id)
        item.id = resp.body.id;
      console.log(JSON.stringify(resp.body))
      dispatch('document', item)
      if (resp.body.success) {
        response = {success: true, message: "Uloženo."}
      } else {
        response = {message: "Soubor nešlo uložit."}
      }
      setTimeout(() => response = null, 3000)
    });
  }
  
  onMount(() => {
  })
</script>
<div class='col-8 d-flex flex-row'>
<div class='btn btn-link text-primary' on:click|preventDefault='{() => window.Back()}' title='na výpis dokumentů'>
<i class='fa fa-arrow-left'></i>
<span class='d-none'>
Zpět
</span>
</div>
<div class='flex-fill'>
<Screen locale='{locale}'></Screen>
</div>
</div>
<div class='col-4'>
<div class='d-flex justify-content-start'>
<div class='btn btn-link text-primary'>
<i class='fa fa-plus'></i>
<span class='d-none'>
Nový
</span>
</div>
</div>
<div class='x_panel'>
<Components locale='{locale}'></Components>
</div>
</div>
